import select from "~/js/select";

interface Profile {
	name: string;
}

if (!localStorage.localprofile)
	localStorage.localprofile = JSON.stringify({
		name:
			"Player #" +
			Math.ceil(Math.random() * 9999)
				.toString()
				.padStart(4, "0"),
	});
export function getProfile(): Profile {
	return JSON.parse(localStorage.localprofile || "{}");
}
function setProfile(profile: Profile) {
	localStorage.localprofile = JSON.stringify(profile);
}
const canvas = document.body.q("canvas", {
	width: 64,
	height: 64,
	style: { opacity: 0, pointerEvents: "none" },
});
const fileInput = document.body.q("input", {
	type: "file",
	accept: "image/png, image/jpeg",
	style: { opacity: 0, pointerEvents: "none" },
	oninput() {
		const ctx = canvas.getContext("2d");
		const reader = new FileReader();
		const file = (this as HTMLInputElement).files?.[0];
		if (!file) return;
		reader.readAsDataURL(file);
		reader.onload = () => {
			const img = new Image();
			img.onload = () => {
				ctx?.fillRect(0, 0, 64, 64);
				ctx?.drawImage(img, 0, 0, 64, 64);
				const dataUrl = canvas.toDataURL();
				localStorage.localprofile_avatar_x64b = dataUrl.substring(22);
				displayPopup();
				updateNavProfile();
			};
			img.src = reader.result as string;
		};
	},
});
export function updateProfilePicture() {
	fileInput.click();
}
export function clearProfilePicture() {
	delete localStorage.localprofile_avatar_x64b;
	displayPopup();
	updateNavProfile();
}
export function getProfilePictureDataURL() {
	return localStorage.localprofile_avatar_x64b ? `data:image/png;base64,${localStorage.localprofile_avatar_x64b}` : "";
}
function updateNavProfile() {
	const nav = select("#nav-profile")!;
	nav.innerHTML = "";
	const profile = getProfile();
	nav.q(".nav-profile-picture", {
		style: {
			backgroundImage: `url(${getProfilePictureDataURL()})`,
			backgroundSize: "100% 100%",
		},
	});
	nav.q(".nav-profile-name", { text: profile.name }).q(".nav-profile-expand");
}
updateNavProfile();
const popup = document.body.q("#local-profile-popup");
export function displayPopup(focusInput: boolean = false) {
	popup.innerHTML = "";
	const profile = getProfile();
	const originalName = profile.name;
	popup.q(".local-pop-notice", "This is how you appear when using online features.");
	const profileContainer = popup.q(".local-pop-profile", [
		q(".local-pop-picture", {
			style: {
				backgroundImage: `url(${getProfilePictureDataURL()})`,
				backgroundSize: "100% 100%",
			},
			onclick() {
				updateProfilePicture();
			},
		}),
		q("input.local-pop-name", {
			value: profile.name,
			maxLength: 20,
			oninput() {
				if (!this.value.trim()) profile.name = originalName;
				else profile.name = this.value.trim();
				setProfile(profile);
				updateNavProfile();
			},
			onblur() {
				this.value = getProfile().name;
			},
		}),
	]);
	if (focusInput) profileContainer.focus();
	popup.classList.add("show");
}
function hidePopup() {
	popup.classList.remove("show");
}
document.addEventListener("mousedown", (e) => {
	let outside = true;
	let target = e.target as HTMLElement | null;
	while (target) {
		if (target === popup) outside = false;
		target = target.parentElement;
	}
	if (outside) hidePopup();
});
select("#nav-profile")!.onclick = () => {
	displayPopup();
};
